import { UpcomingShowGiveawayItemApi } from '../../generated/api';
import configuration from './configuration';

export const upcomingShowGiveawayService = new UpcomingShowGiveawayItemApi(
  configuration,
);
